export const REQUIREMENTS_TRANSLATION_NAMESPACE = 'features/requirements';
